const mapping = { plants: "plant", process_orders: "process_order", materials: "material", storage_locations: "storage_location", batch: "batch", company_code: "company_code" };
const multi = new Set(["plants", "process_orders", "materials", "storage_locations"]);
const parents = { company_code: [], plants: ["company_code"], materials: ["company_code", "plants"], process_orders: ["company_code", "plants", "materials"], storage_locations: ["company_code", "plants"], batch: ["company_code", "plants", "materials", "process_orders", "storage_locations"] };
const normalized = value => String(value || "").replace(/^0+(?=.)/, "");
export function receiptOptions(records, filters, field) {
  const options = new Map();
  for (const row of records) {
    const matches = Object.entries(mapping).every(([key, column]) => {
      if (!parents[field].includes(key) || !filters[key]) return true;
      const values = multi.has(key) ? filters[key].split(",").map(value => value.trim()).filter(Boolean) : [filters[key]];
      return values.some(value => normalized(value) === normalized(row[column]));
    });
    if (!matches || !row[mapping[field]]) continue;
    const code = row[mapping[field]];
    const extra = field === "materials" ? row.material_description : ["process_orders", "storage_locations", "batch"].includes(field) ? `Plant ${row.plant}${field === "batch" ? ` · ${row.material}` : ""}` : "";
    const label = extra && extra !== code ? `${code} — ${extra}` : code;
    // A shared storage/batch code remains one selection; show all relevant contexts.
    if (!options.has(code)) options.set(code, { code, labels: new Set() });
    options.get(code).labels.add(label);
  }
  return [...options.values()].map(({ code, labels }) => ({ code, label: [...labels].sort().join(" / ") })).sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));
}

export function updateProductionFilter(previous, key, value) {
  const descendants = { company_code: ["plants", "materials", "process_orders", "storage_locations", "batch"], plants: ["materials", "process_orders", "storage_locations", "batch"], materials: ["process_orders", "batch"], process_orders: ["batch"], storage_locations: ["batch"] };
  if (previous[key] === value) return previous;
  const next = { ...previous, [key]: value };
  for (const child of descendants[key] || []) next[child] = "";
  return next;
}
